import React from "react";
import { Link } from "react-router-dom";
import {
  FaHome,
  FaArrowLeft,
  FaSearch,
  FaBowlingBall,
  FaUsers,
} from "react-icons/fa";
import { useTournamentId, useTournamentSlug } from "../../context/TournamentRouteContext";
import { tournamentPath } from "../../utility/tournamentUrls";

const SquadNotFound = () => {
  const tournamentId = useTournamentId();
  const tournamentSlug = useTournamentSlug();

  return (
    <div className="min-h-screen bg-brand-cream flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="card-board p-8">
          {/* Icon */}
          <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-lg bg-red-100 mb-6">
            <FaUsers className="h-8 w-8 text-red-600" />
          </div>

          {/* Error Code */}
          <h1 className="heading-display text-6xl mb-4">404</h1>

          {/* Title */}
          <h2 className="heading-display text-2xl mb-4">
            Squad Not Found
          </h2>

          {/* Description */}
          <p className="text-brand-muted mb-8 leading-relaxed">
            The squad you're looking for doesn't exist or may have been removed.
            The squad ID might be incorrect or the squad may have been deleted.
          </p>

          {/* Action Buttons */}
          <div className="space-y-4">
            {tournamentId && (
              <Link
                to={tournamentPath(tournamentSlug, `/squads`)}
                className="w-full inline-flex items-center justify-center px-6 py-3 rounded-lg text-base font-display font-bold tracking-wide text-brand-charcoal bg-brand-cream border border-brand-charcoal/20 hover:border-brand-gold-ink"
              >
                <FaSearch className="mr-2 h-5 w-5" />
                View All Squads
              </Link>
            )}

            <Link
              to="/tournaments"
              className="w-full inline-flex items-center justify-center px-6 py-3 rounded-lg text-base font-display font-bold tracking-wide text-brand-charcoal bg-brand-cream border border-brand-charcoal/20 hover:border-brand-gold-ink"
            >
              <FaBowlingBall className="mr-2 h-5 w-5" />
              Browse Tournaments
            </Link>

            <Link
              to="/"
              className="w-full inline-flex items-center justify-center px-6 py-3 rounded-lg text-base font-display font-bold tracking-wide text-brand-charcoal bg-brand-cream border border-brand-charcoal/20 hover:border-brand-gold-ink"
            >
              <FaHome className="mr-2 h-5 w-5" />
              Go to Home
            </Link>

            <button
              onClick={() => window.history.back()}
              className="w-full inline-flex items-center justify-center px-6 py-3 rounded-lg text-base font-display font-bold tracking-wide text-brand-charcoal bg-brand-cream border border-brand-charcoal/20 hover:border-brand-gold-ink"
            >
              <FaArrowLeft className="mr-2 h-5 w-5" />
              Go Back
            </button>
          </div>

          {/* Help Text */}
          <div className="mt-8 pt-6 border-t border-brand-charcoal/10">
            <p className="text-sm text-brand-muted">
              If you believe this is an error, please{" "}
              <Link
                to="/support/contact"
                className="text-brand-gold-ink hover:text-brand-charcoal underline"
              >
                contact support
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SquadNotFound;
